<script setup lang="ts">
import PartAppThemeSwitcher from '@parts/part-app-theme-switcher.vue';
import FormSelect from '@form/form-select.vue';
import {useCommonStore} from '@store/common';
import {computed} from 'vue';
import {useUserStore} from '@store/user';
import {storeToRefs} from 'pinia';

const commonStore = useCommonStore();
const userStore = useUserStore();
const {user} = storeToRefs(userStore);
const { languages } = storeToRefs(commonStore);

const languagesSelectList = computed(() => {
	return languages.value.map((lang) => ({
		label: lang.name,
		value: lang.locale,
	}));
});

</script>

<template>
	<div class="part-header-desktop">
		<part-app-theme-switcher class="part-header-desktop__theme" />
		<form-select
			name="lang"
			:icon="{ name: 'website', viewBox: '0 0 25 24' }"
			:list="languagesSelectList"
			v-model="user.lang"
			class="part-header-desktop__lang"
		/>
	</div>
</template>

<style lang="scss">
.part-header-desktop {
	padding: 1.6rem 1.2rem;
	display: flex;
	gap: 1.6rem;

	&__lang {
		min-width: 15rem;
	}
}
</style>
